export default __webpack_public_path__ + "static/media/outlook_logo.06eb6f06.svg";